
<picture class="media-container" *ngIf="($src | push: strategy)" >
	<img 
		class="background-image" 
		[alt]="alt" 
		[srcset]="($srcset | push)"
		[sizes]="($sizes | push)"
		[src]="($src | push)" 
		[attr.loading]="loading" 
		(load)="imageLoaded($event)" 
		[ngClass]="position"
		[class.loaded]="($loaded | push)"
	/>	
</picture>

